import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ROLE_AGENTE_ENVIO } from "src/app/constantes/permissao.constants";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ExportacaoGestorService } from "../exportacao/exportacao-gestor.service";
import { FileUtilsService } from "src/app/shared/file-utils.service";

@Component({
    selector: "app-empresas-bloqueadas-pesquisa",
    templateUrl: "./empresas-bloqueadas-pesquisa.component.html",
    standalone: false
})
export class EmpresasBloqueadasPesquisaComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject();
  naoPodeConsultarEmpresasBloqueadas: boolean = true;

  constructor(private permissaoService: PermissaoService,
    private gestorService: ExportacaoGestorService,
    private fileUtils: FileUtilsService,) {}

  ngOnInit() {
    this.permissaoService.getPermissoesUsuarioAutenticado()
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: any) => {
      const ehAgenteEnvio = resp && resp[ROLE_AGENTE_ENVIO];
      this.naoPodeConsultarEmpresasBloqueadas = !ehAgenteEnvio;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  baixarEmpresasBloqueadas() {
    if(this.naoPodeConsultarEmpresasBloqueadas) {
      this.gestorService.getEmpresasBloqueadas().subscribe((conteudoArquivo) => {
        this.fileUtils.exportarArquivoUTF8('empresas_bloqueadas.csv',
            conteudoArquivo, FileUtilsService.TEXT_CSV);
      });
    }
}
}
